import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import './css/Gallery.css';

import a2 from '../img/barilga/4.png';
import a3 from '../img/barilga/5.png';

const galleryImages = [
    { image: a2, alt: 'Б Блок 2 Давхар' },
    { image: a3, alt: 'Б Блок 3 Давхар' },
];

const CustomArrow = ({ direction, onClick }: { direction: 'left' | 'right', onClick: () => void }) => (
    <button
        onClick={onClick}
        className={`custom-arrow ${direction}-arrow`}
        aria-label={direction === 'left' ? 'Previous slide' : 'Next slide'}
    >
        <span className="arrow-icon">{direction === 'left' ? '<' : '>'}</span>
    </button>
);

const Gallery2: React.FC = () => {
    return (
        <div className="gallery">
            <div className="fullscreen-carousel-wrapper">
                <Carousel
                    autoPlay
                    infiniteLoop
                    showThumbs={false}
                    showStatus={false}
                    showIndicators={true}
                    interval={5000}
                    swipeable
                    emulateTouch
                    stopOnHover={false}
                    dynamicHeight={false}
                    transitionTime={500}
                    renderArrowPrev={(onClickHandler, hasPrev) =>
                        hasPrev && <CustomArrow direction="left" onClick={onClickHandler} />
                    }
                    renderArrowNext={(onClickHandler, hasNext) =>
                        hasNext && <CustomArrow direction="right" onClick={onClickHandler} />
                    }
                >
                    {galleryImages.map((image, index) => (
                        <div key={index} className="fullscreen-slide">
                            <div className="slide-content">
                                <img src={image.image} alt={image.alt} className="fullscreen-image" />
                                <div className="slide-overlay" />
                            </div>
                        </div>
                    ))}
                </Carousel>
            </div>
        </div>
    );
};

export default Gallery2;